import React, { forwardRef } from 'react';

import { useGetLists } from '@vlabs/api/artemy/client';
import { Radio } from '@vlabs/uikit/components/controls/radio/Radio.js';

import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function ListsFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();
  const getLists = useGetLists({ page_size: 1000 });
  const listsOptions: Option[] = getLists.data?.lists?.map((list) => ({
    value: list.list_id,
    label: list.user_data,
  })) ?? [];

  const selectedList = filters.top_matching_candidates_label;

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={!selectedList}
      onClickReset={() => updateFilters({ top_matching_candidates_label: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {listsOptions.map((option: Option) => (
          <Radio
            checked={selectedList === option.value}
            key={option.value}
            label={option.label}
            onChange={() => updateFilters({ top_matching_candidates_label: option.value })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const ListsFilterPopoverWithRef = forwardRef(ListsFilterPopover);
export { ListsFilterPopoverWithRef as ListsFilterPopover };
